<template>
    <div class="col-md-12">
        <base-button block type="default" class="icon icon-shape border-success bg-success rounded-circle text-white mt--6 float-right" @click="modalAdd = true">
            <i class="ni ni-fat-add"></i>
        </base-button>

        <modal :show.sync="modalAdd"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-xl">
            <base-header class="header pb-2 pb-2 pt-5 pt-md-8 d-flex align-items-center">
                <!-- Mask -->
                <span class="mask bg-gradient-login_varient opacity-8"></span>
                <!-- Header container -->
            </base-header>

            <div class="container-fluid mt--7">
                <div class="row">
                    <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Ajouter une facture</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                
                                <h6 class="heading-small text-muted mb-4">Informations Générales</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Numéro de facture"
                                                        placeholder="Numéro"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                                        v-model="facture.numero"
                                            />
                                            <transition name="fade">
                                                <div  v-if="numeroMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    Le numéro est manquant.
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input label="Date" :required="required">
                                                <flat-picker slot-scope="{focus, blur}"
                                                            @on-open="focus"
                                                            @on-close="blur"
                                                            :config="{allowInput: true, dateFormat: 'Y-m-d',}"
                                                            placeholder="Date de la facture"
                                                            v-model="facture.date"
                                                            class="form-control form-control-alternative datepicker"/>
                                            </base-input>
                                            <transition name="fade">
                                                <div  v-if="dateMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    La Date est manquante.
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input label="Fournisseur"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                            >
                                                <InputSelect :options="fournisseur" 
                                                             :reduce="fournisseur => fournisseur.idFournisseur" 
                                                             label="nom" 
                                                             v-model="facture.idFournisseur"
                                                             class="form-control form-control-alternative style-chooser"/>
                                            </base-input>
                                            <transition name="fade">
                                                <div  v-if="fournisseurMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    Le fournisseur est manquant.
                                                </div>
                                            </transition>
                                            
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Informations Réglements</h6>
                                <div class="pl-lg-4"> 
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Montant HT"
                                                        placeholder="Montant HT"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                                        v-model="facture.montantHT"
                                            />
                                            <transition name="fade">
                                                <div  v-if="montanthtMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    Le montant HT est manquant.
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Montant TTC"
                                                        placeholder="Montant TTC"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                                        v-model="facture.montantTTC"
                                            />
                                            <transition name="fade">
                                                <div  v-if="montantttcMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    Le montant TTC est manquant.
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input label="Devise"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                            >
                                                <InputSelect :options="devise" 
                                                             :reduce="devise => devise.idDevise" 
                                                             label="nom" 
                                                             class="form-control form-control-alternative style-chooser"
                                                             v-model="facture.idDevise"/>
                                            </base-input>
                                            
                                        </div>
                                            <transition name="fade">
                                                <div  v-if="deviseMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    La devise est manquante.
                                                </div>
                                            </transition>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input label="Date de réglement maximum" input-classes="form-control-alternative" :required="required">
                                                <flat-picker slot-scope="{focus, blur}"
                                                            @on-open="focus"
                                                            @on-close="blur"
                                                            :config="{allowInput: true, dateFormat: 'Y-m-d',}"
                                                            placeholder="Date de réglement maximum de la facture"
                                                            class="form-control form-control-alternative datepicker"
                                                            v-model="facture.dateReglementMax"/>
                                            </base-input>
                                            <transition name="fade">
                                                <div  v-if="reglementmaxMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    La date de réglement maximum est manquante.
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input label="Date de réglement (si déjà effectué)">
                                                <flat-picker slot-scope="{focus, blur}"
                                                            @on-open="focus"
                                                            @on-close="blur"
                                                            :config="{allowInput: true, dateFormat: 'Y-m-d',}"
                                                            placeholder="Date de réglement de la facture"
                                                            v-model="facture.dateReglement"
                                                            class="form-control form-control-alternative datepicker"/>
                                            </base-input>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Fichier</h6>
                                <div class="pl-lg-4"> 
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Nom du fichier"
                                                        placeholder="Nom du fichier"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                                        v-model="facture.nameFile"
                                            />
                                            <transition name="fade">
                                                <div  v-if="namefileMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    Le nom du fichier est manquant.
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input label="Fichier" :required="required"><br>
                                                <InputFile v-on:input="handleFileChange" v-model="file"></InputFile>
                                            </base-input>
                                            <transition name="fade">
                                                <div  v-if="fileMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    Le fichier est manquant.
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                                
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Etat</h6>
                                <div class="pl-lg-4"> 
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input label="Etat Réception"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                            >
                                                <InputSelect :options="etatreception" 
                                                             :reduce="etatreception => etatreception.idEtatReception" 
                                                             label="label" 
                                                             class="form-control form-control-alternative style-chooser"
                                                             v-model="facture.idEtatReception"/>
                                            </base-input>
                                            <transition name="fade">
                                                <div  v-if="etatreceptionMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    L'état réception est manquant.
                                                </div>
                                            </transition>
                                            
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input label="Etat Paiement"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                            >
                                                <InputSelect :options="etatpaiement" 
                                                             :reduce="etatpaiement => etatpaiement.idEtatPaiement" 
                                                             label="label" 
                                                             class="form-control form-control-alternative style-chooser"
                                                             v-model="facture.idEtatPaiement"/>
                                            </base-input>
                                            <transition name="fade">
                                                <div  v-if="etatpaiementMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    L'état paiement est manquant.
                                                </div>
                                            </transition>
                                            
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <base-button v-on:click="submitForm" type="success col-lg-12">Ajouter cette facture</base-button><br><br>
                                <center><div v-if="loadingAddFacture" class="lds-ring"><div></div><div></div><div></div><div></div></div></center>
                                <transition name="fade">
                                    <div  v-if="errorfacture" 
                                        class="alert alert-danger" 
                                        role="alert">
                                        Problème lors de l'ajout...
                                    </div>
                                    <div  v-if="goodfacture" 
                                        class="alert alert-success" 
                                        role="alert">
                                        Facture ajouté
                                    </div>
                                </transition>
                            </form>
                        </template>
                    </card>
                </div>
                </div>
                <br>
            </div>
        </modal>
    </div>
</template>
<script>
import constvar from '@/const'
import router from '@/router'
import modal from "@/components/Modal";
import InputFile from "@/components/InputFile";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import InputSelect from 'vue-select'
import "vue-select/src/scss/vue-select.scss";

export default {
    name: "FactureAddModal",
    components: {
        modal,
        InputFile,
        flatPicker,
        InputSelect,
    },
    data() {
      return {
        modalAdd: false,
        required: true,
        devise: [],
        fournisseur: [],
        etatpaiement: [],
        etatreception: [],
        facture: {
            numero: '',
            date: '',
            montantHT: '',
            montantTTC: '',
            dateReglementMax: '',
            dateReglement: '',
            nameFile: '',
            contentFile: '',
            idFournisseur: '',
            idDevise: '',
            idEtatPaiement: '',
            idEtatReception: '',
        },
        errorfacture: false,
        goodfacture: false,
        file: null,
        numeroMissing: 0,
        dateMissing: 0,
        montanthtMissing: 0,
        montantttcMissing: 0,
        reglementmaxMissing: 0,
        namefileMissing: 0,
        fileMissing: 0,
        fournisseurMissing: 0,
        etatpaiementMissing: 0,
        etatreceptionMissing: 0,
        deviseMissing: 0,
        loadingAddFacture:0,
      }
    },
    async created() {
        const devise = await fetch(constvar.api_url+'devise', {
            method: 'GET',
            credentials: 'include',
        });
        if(devise.ok) { 
            const devisejson = await devise.json();
            if(devisejson.code != 409) {
                this.devise = devisejson;
                this.facture.idDevise = devisejson[0].idDevise
            } else { 
                router.push("login")    
            }
        } 
        const fournisseur = await fetch(constvar.api_url+'fournisseur', {
            method: 'GET',
            credentials: 'include',
        });
        if(fournisseur.ok) { 
            const fournisseurjson = await fournisseur.json();
            if(fournisseurjson.code != 409) {
                this.fournisseur = fournisseurjson;
            } else { 
                router.push("login")    
            }
        } 
        const etatreception = await fetch(constvar.api_url+'etatreception', {
            method: 'GET',
            credentials: 'include',
        });
        if(etatreception.ok) { 
            const etatreceptionjson = await etatreception.json();
            if(etatreceptionjson.code != 409) {
                this.etatreception = etatreceptionjson;
                this.facture.idEtatReception = etatreceptionjson[0].idEtatReception
            } else { 
                router.push("login")    
            }
        } 
        const etatpaiement = await fetch(constvar.api_url+'etatpaiement', {
            method: 'GET',
            credentials: 'include',
        });
        if(etatpaiement.ok) { 
            const etatpaiementjson = await etatpaiement.json();
            if(etatpaiementjson.code != 409) {
                this.etatpaiement = etatpaiementjson;
                this.facture.idEtatPaiement = etatpaiementjson[0].idEtatPaiement
            } else { 
                router.push("login")    
            }
        } 
    },
    methods: {
        handleFileChange: function(file) {
            this.facture.contentFile = file
            this.facture.nameFile = file.name
        },
        submitForm: async function() {
            if(!this.facture.numero) { this.numeroMissing = 1 } else { this.numeroMissing = 0 }
            if(!this.facture.date) { this.dateMissing = 1 } else { this.dateMissing = 0 }
            if(!this.facture.montantHT) { this.montanthtMissing = 1 } else { this.montanthtMissing = 0 }
            if(!this.facture.montantTTC) { this.montantttcMissing = 1 } else { this.montantttcMissing = 0 }
            if(!this.facture.dateReglementMax) { this.reglementmaxMissing = 1 } else { this.reglementmaxMissing = 0 }
            if(!this.facture.nameFile) { this.namefileMissing = 1 } else { this.namefileMissing = 0 }
            if(!this.facture.contentFile) { this.fileMissing = 1 } else { this.fileMissing = 0 }
            if(!this.facture.idFournisseur) { this.fournisseurMissing = 1 } else { this.fournisseurMissing = 0 }
            if(!this.facture.idEtatPaiement) { this.etatpaiementMissing = 1 } else { this.etatpaiementMissing = 0 }
            if(!this.facture.idEtatReception) { this.etatreceptionMissing = 1 } else { this.etatreceptionMissing = 0 }
            if(!this.facture.idDevise) { this.deviseMissing = 1 } else { this.deviseMissing = 0 }
            if(this.numeroMissing || this.dateMissing || this.montanthtMissing || this.montantttcMissing || this.reglementmaxMissing || this.namefileMissing || this.fileMissing || this.fournisseurMissing || this.etatpaiementMissing || this.etatreceptionMissing || this.deviseMissing) { return; }
            this.loadingAddFacture = 1;
            this.facture.montantHT = String(this.facture.montantHT).replace(",", ".")
            this.facture.montantTTC = String(this.facture.montantTTC).replace(",", ".")

            const params = new FormData();
            params.append('numero', this.facture.numero);
            params.append('date', this.facture.date);
            params.append('montantHT', this.facture.montantHT);
            params.append('montantTTC', this.facture.montantTTC);
            params.append('dateReglementMax', this.facture.dateReglementMax);
            params.append('dateReglement', this.facture.dateReglement);
            params.append('nameFile', this.facture.nameFile);
            params.append('contentFile', this.facture.contentFile, "file.pdf");
            params.append('idFournisseur', this.facture.idFournisseur);
            params.append('idDevise', this.facture.idDevise);
            params.append('idEtatPaiement', this.facture.idEtatPaiement);
            params.append('idEtatReception', this.facture.idEtatReception);

    
            const response = await fetch(constvar.api_url+'facture', {
                method: 'POST',
                credentials: 'include',
                body: params
            });
            const json = await response.json();
            if(json.id) {
                this.$emit('factureadded', true)
                this.loadingAddFacture = 0;
                this.modalAdd = false
            } else {
                this.loadingAddFacture = 0;
                this.errorfacture = true
                setTimeout(()=>{
                this.errorfacture = false
                },3000);
            } 
        },
    },
    watch: {
    }
};
</script>
<style>
    .style-chooser .vs__dropdown-toggle {
        border: none;
    }
    .lds-ring {
        display: inline-block;
        position: relative;
        width: 64px;
        height: 64px;
        margin:auto
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 51px;
        height: 51px;
        margin: 6px;
        border: 6px solid black;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: rgb(146, 146, 146) transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>